import { render } from "./d-baccarat-bet-view.vue?vue&type=template&id=edff704e&scoped=true&ts=true"
import script from "./d-baccarat-bet-view.vue?vue&type=script&lang=ts"
export * from "./d-baccarat-bet-view.vue?vue&type=script&lang=ts"

import "./d-baccarat-bet-view.vue?vue&type=style&index=0&id=edff704e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edff704e"]])

export default __exports__